<div class="container">
    <button
        mat-raised-button
        class="returnButton"
        color="accent"
        (click)="loadBack()"
    >
        <mat-icon aria-label="Calculate">keyboard_backspace</mat-icon>
        {{ "dashboardBizzDev.returnButton.fullLabel" | translate }}
    </button>
</div>
<div class="dashboard-advanced-overview">
    <!-- IDENTITY CARD -->
    <mat-card class="cityDetails-Label">
        <ng-container *ngIf="cityGeneralInformation">
            <mat-card-header class="not-selected">
                <mat-card-title class="not-selected">
                    <h4>
                        {{ cityGeneralInformation.fullLabel }}
                    </h4>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content class="table-height">
                <section>
                    <table>
                        <tbody>
                            <tr>
                                <td class="labelDate">
                                    {{
                                        "dashboardBizzDev.details.city.table.header.region.shortLabel"
                                            | translate
                                    }}
                                </td>
                                <td>
                                    <b>{{ cityGeneralInformation.region }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td class="labelDate">
                                    {{
                                        "dashboardBizzDev.details.city.table.header.province.shortLabel"
                                            | translate
                                    }}
                                </td>
                                <td>
                                    <b>{{ cityGeneralInformation.province }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td class="labelDate">
                                    {{
                                        "dashboardBizzDev.details.city.table.header.arrondissement.shortLabel"
                                            | translate
                                    }}
                                </td>
                                <td>
                                    <b>{{
                                        cityGeneralInformation.arrondissement
                                    }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td class="labelDate">
                                    {{
                                        "dashboardBizzDev.details.city.table.header.cluster.shortLabel"
                                            | translate
                                    }}
                                </td>
                                <td>
                                    <b>{{ cityGeneralInformation.cluster }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td class="labelDate">
                                    {{
                                        "dashboardBizzDev.details.city.table.header.ins.shortLabel"
                                            | translate
                                    }}
                                </td>
                                <td>
                                    <b>{{ cityGeneralInformation.ins }}</b>
                                </td>
                            </tr>
                            <ng-container
                                *ngIf="
                                    cityGeneralInformation.licenceType != '-';
                                    else hasNoLicence
                                "
                            >
                                <tr>
                                    <td colspan="3">
                                        <hr />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="labelDate">
                                        {{
                                            "dashboardBizzDev.details.city.table.header.licence.shortLabel"
                                                | translate
                                        }}
                                    </td>
                                    <td>
                                        <b>{{
                                            cityGeneralInformation.licenceType
                                        }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="labelDate">
                                        {{
                                            "dashboardBizzDev.details.city.table.header.startDate.fullLabel"
                                                | translate
                                        }}
                                    </td>
                                    <td>
                                        <b>{{
                                            cityGeneralInformation.licenceStartDate
                                        }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="labelDate">
                                        {{
                                            "dashboardBizzDev.details.city.table.header.endDate.fullLabel"
                                                | translate
                                        }}
                                    </td>
                                    <td>
                                        <b>{{
                                            cityGeneralInformation.licenceEndDate
                                        }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="labelDate">
                                        {{
                                            "dashboardBizzDev.details.city.table.header.bankerEmail.fullLabel"
                                                | translate
                                        }}
                                    </td>
                                    <td>
                                        <b>{{ bankerEmail }}</b>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #hasNoLicence>
                                <p
                                    [ngStyle]="{
                                        color: 'red',
                                        'text-align': 'center'
                                    }"
                                >
                                    {{
                                        "dashboardBizzDev.details.city.table.body.noLicence.fullLabel"
                                            | translate
                                    }}
                                </p>
                            </ng-template>
                            <tr>
                                <td colspan="3">
                                    <hr />
                                </td>
                            </tr>
                            <tr>
                                <td class="labelDate">
                                    {{
                                        "dashboardBizzDev.details.city.table.header.public.shortLabel"
                                            | translate
                                    }}
                                </td>
                                <ng-container
                                    *ngIf="
                                        cityGeneralInformation.isPublic;
                                        else isNotPublic
                                    "
                                >
                                    <td>
                                        <b>{{
                                            "dashboardBizzDev.details.city.table.body.yes.shortLabel"
                                                | translate
                                        }}</b>
                                    </td>
                                </ng-container>
                                <ng-template #isNotPublic>
                                    <b>{{
                                        "dashboardBizzDev.details.city.table.body.no.shortLabel"
                                            | translate
                                    }}</b>
                                </ng-template>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <hr />
                                </td>
                            </tr>
                            <ng-container
                                *ngIf="
                                    cityGeneralInformation.numberConnexion > 0;
                                    else noConnexion
                                "
                            >
                                {{ cityGeneralInformation.numberConnexion }}
                                {{
                                    "dashboardBizzDev.details.city.table.body.lastConnexion.fullLabel"
                                        | translate
                                }}
                            </ng-container>
                            <ng-template #noConnexion>
                                {{
                                    "dashboardBizzDev.details.city.table.body.noConnexion.fullLabel"
                                        | translate
                                }}
                            </ng-template>
                        </tbody>
                    </table>
                </section>
            </mat-card-content>
        </ng-container>
    </mat-card>
    <!-- YEARS LISTING -->
    <mat-card class="cityDetails-Year">
        <mat-card-header class="not-selected">
            <mat-card-title class="not-selected">
                <h4>
                    {{
                        "dashboardBizzDev.details.city.detail.title.fullLabel"
                            | translate
                    }}
                </h4>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="table-height">
            <section>
                <table
                    mat-table
                    [dataSource]="dataSource"
                    matSort
                    class="tab-content"
                >
                    <!-- ID Column -->
                    <ng-container matColumnDef="yearID">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{
                                "dashboardBizzDev.details.city.detail.table.yearID.shortLabel"
                                    | translate
                            }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.yearID }}
                        </td>
                    </ng-container>

                    <!-- dataType Column -->
                    <ng-container matColumnDef="dataType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{
                                "dashboardBizzDev.details.city.detail.table.dataType.shortLabel"
                                    | translate
                            }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.dataType }}
                        </td>
                    </ng-container>

                    <!-- Budget Column -->
                    <ng-container matColumnDef="importDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{
                                "dashboardBizzDev.details.city.detail.table.importDate.shortLabel"
                                    | translate
                            }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.importDate | date: "dd/MM/yyyy HH:mm" }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let element; columns: displayedColumns"
                    ></tr>
                </table>
            </section>
        </mat-card-content>
    </mat-card>
</div>
